var wrap = function (toWrap, wrapper) {
    wrapper = wrapper || document.createElement('div');
    toWrap.parentNode.appendChild(wrapper);
    return wrapper.appendChild(toWrap);
};

class Item
{
    constructor(elem, toggleText) {
        this.elem = elem
        this.header = elem.querySelector('header')
        this.body = elem.querySelector('.content')

        if (!this.header || !this.body) {
            throw new Error('accordion item must contain a "header" and ".content" element')
        }

        this.expandedHeight = 0
        this.expanded = true
        this.toggleLink = null

        if (!this.header) {
            throw new Error('accordion section must contain a "header" element')
        }

        const newHeader = document.createElement('div')
        newHeader.classList.add('accordion-header')

        const toggleLink = document.createElement('a')
        toggleLink.href = 'javascript:void(0);';
        toggleLink.classList.add('accordion-toggle')
        toggleLink.innerHTML = `${toggleText} <span class="arrow"></span>`
        toggleLink.addEventListener('click', this.toggle.bind(this))

        this.toggleLink = toggleLink

        wrap(this.header, newHeader)
        newHeader.appendChild(toggleLink);

        this.header.addEventListener('click', this.toggle.bind(this))

        this.elem.insertBefore(newHeader, this.elem.firstChild)

        this.loadSize()
        this.toggle()

        window.addEventListener('resize', this.loadSize.bind(this))
    }

    toggle() {
        this.expanded = !this.expanded
        this.body.style.maxHeight = `${this.expanded ? this.expandedHeight : 0}px`

        if (this.expanded) {
            this.elem.classList.add('expanded')
        } else {
            this.elem.classList.remove('expanded')
        }
    }

    loadSize() {
        this.expandedHeight = this.body.scrollHeight

        if (this.expandedHeight === 0) {
            this.toggleLink.style.display = 'none'
        } else {
            this.toggleLink.style.display = 'block'
        }

        if (this.expanded) {
            this.body.style.maxHeight = `${this.expandedHeight}px`
        }
    }
}

class List
{
    constructor(elem) {
        this.elem = elem

        const toggleText = this.elem.getAttribute('data-label') || ''

        elem.querySelectorAll('li').forEach(li => new Item(li, toggleText))
    }
}

class SFAccordion
{
    constructor() {
        this.sections = []

        document.querySelectorAll('ul.accordion').forEach(section => {
            try {
                this.sections = new List(section)
            } catch (e) {
                console.error(e)
            }
        })
    }
}

export default SFAccordion
